const { h, Component, createRef } = require('preact');

const add = (cl, arr) => {
    if(arr.indexOf(cl) == -1) {
        return [cl, ...arr];
    }
    return arr;
}
const rem = (cl, arr) => {
    const i = arr.indexOf(cl);
    if(i == -1) {
        return arr;
    }
    let newArr = [...arr];
    newArr.splice(i, 1);
    return newArr;
}

class FBInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            classes: []
        };
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }

    appendFilled(val, classes) {
        let cl;
        if(!val) {
            cl = rem('filled', classes);
        } else {
            cl = add('filled', classes);
        }
        return cl;
    }

    handleInput(e) {
        const newVal = e.target.value;
        if(!newVal) {
            this.setState((state, props) => ({ classes: rem('filled', state.classes) }));
        } else {
            this.setState((state, props) => ({ classes: add('filled', state.classes) }));
        }
        this.props.onInput(newVal);
    }

    handleFocusIn() {
        this.setState((state, props) => {
            let cl = add('focused', state.classes);
            cl = this.appendFilled(props.value, cl);
            return {
                classes: cl
            };
        });
    }

    handleFocusOut() {
        this.setState((state, props) => {
            let cl = rem('focused', state.classes);
            cl = this.appendFilled(props.value, cl);
            return {
                classes: cl
            };
        });
    }

    render({ id, label, valid=true, value, maxlength }, { classes }) {
        return (
            <div class="form-v2-1">
                <div class={["gig-field", ...classes].join(' ') }>
                    <label for={id}>{label}</label>
                    <input maxlength={maxlength} required="true" data-bhw="web2018_facebook_order_id_input" onInput={this.handleInput} onfocusin={this.handleFocusIn} onfocusout={this.handleFocusOut} value={value} id={id} type="text" invalid={!valid}></input>
                </div>
                <span class="form-field-help">{I18n.translate('js.modules.web_2018.facebook_order_id_help_text')}</span>
            </div>
        )
    }
}

module.exports = FBInput
